// Imports
import React from 'react';
import { Col, Row } from '../../../../grid';


const RenderProductPageDescription = ({
  productPageDescription,
  productPageDescriptionLong,
}) => {
  if (productPageDescriptionLong) {
    return null;
  }
  if (productPageDescription) {
    return (
      <Row>
        <Col xs={12}>
          {productPageDescription()}
        </Col>
      </Row>
    );
  }
  return null;
};

// Export
export default RenderProductPageDescription;
